import React, { FC } from 'react';
import { SettingsFormPageSkeleton, SettingsTablePageSkeleton } from '../settings/settingsSkeleton';

export const AdditionalAttributesPageSkeleton: FC = () => <SettingsTablePageSkeleton />;
export const AdditionalAttributePageSkeleton: FC = () => <SettingsFormPageSkeleton />;
